/* Produktdaten – erzeugt aus produkte_komplett.json (Stand 09.10.2026) */
window.PRODUKTE = [
 {
  "id": "jura-3-phasen-reinigungstabletten-25-stuck-1",
  "gruppe": "jura-3-phasen-reinigungstabletten-25-stuck-1",
  "art": "mehr",
  "marke": "jura",
  "hersteller": "Jura",
  "kat": "Kaffee-Pflege",
  "titel": "Jura 3-Phasen-Reinigungstabletten - 25 Stück",
  "kurz": "Jura 3-Phasen-Reinigungstabletten",
  "variante": "",
  "text": "Original JURA Reinigungstabletten für alle JURA Kaffeevollautomaten – reinigen, pflegen und schützen in einem Schritt.",
  "features": [
   "Kompatibel mit allen JURA Kaffeevollautomaten",
   "3-Phasen-Wirkung: Reinigung, Pflege, Schutz",
   "25 Tabletten im Vorratspack"
  ],
  "ziel": [],
  "bilder": [
   "bilder/jura-3-phasen-reinigungstabletten-25-stuck-1_01.jpg",
   "bilder/jura-3-phasen-reinigungstabletten-25-stuck-1_02.jpg",
   "bilder/jura-3-phasen-reinigungstabletten-25-stuck-1_03.jpg"
  ],
  "optionen": [],
  "varianten": [
   {
    "opts": {},
    "ean": "7610917250455",
    "preis": 42.50,
    "bild": "bilder/jura-3-phasen-reinigungstabletten-25-stuck-1_01.jpg",
    "stueck": 25,
    "einheit": "Tabletten"
   }
  ],
  "passt": []
 },
 {
  "id": "philips-sonicare-c3-premium-plaque-defense-burstenkopfe-4er-pack-hx9044-87-1",
  "gruppe": "philips-sonicare-c3-premium-plaque-defense-burstenkopfe-4er-pack-hx9044-87",
  "art": "kopf",
  "marke": "sonicare",
  "titel": "Philips Sonicare C3 Premium Plaque Defense Bürstenköpfe (4er-Pack) HX9044/87 - HX9044/88",
  "kurz": "Sonicare C3 Premium Plaque Defense",
  "variante": "Schwarz · 4 Stück",
  "text": "Der Plaque-Spezialist: flexible Seitenborsten schmiegen sich an die Zahnform an und lösen bis zu 10× mehr Plaque als eine Handzahnbürste.",
  "features": [
   "Bis zu 10× mehr Plaque-Entfernung*",
   "Flexible Seitenwände für engen Zahnkontakt",
   "BrushSync™-Chip: Handstück erinnert an den Wechsel",
   "Mittelweiche Borsten"
  ],
  "ziel": [
   "plaque"
  ],
  "bilder": [
   "bilder/philips-sonicare-c3-premium-plaque-defense-burstenkopfe-4er-pack-hx9044-87_05.jpg",
   "bilder/philips-sonicare-c3-premium-plaque-defense-burstenkopfe-4er-pack-hx9044-87_02.jpg",
   "bilder/philips-sonicare-c3-premium-plaque-defense-burstenkopfe-4er-pack-hx9044-87_03.jpg",
   "bilder/philips-sonicare-c3-premium-plaque-defense-burstenkopfe-4er-pack-hx9044-87_04.jpg"
  ],
  "optionen": [],
  "varianten": [
   {
    "opts": {
     "Farbe": "schwarz"
    },
    "ean": "8710103805625",
    "preis": 47.79,
    "bild": "bilder/philips-sonicare-c3-premium-plaque-defense-burstenkopfe-4er-pack-hx9044-87_05.jpg",
    "stueck": 4
   }
  ],
  "passt": [
   "son-2100",
   "son-3100",
   "son-4100",
   "son-5300",
   "son-6100",
   "son-7100",
   "son-9000",
   "son-9900",
   "son-kids"
  ]
 },
 {
  "id": "philips-sonicare-c3-premium-plaque-defense-burstenkopfe-4er-pack-hx9044-87-2",
  "gruppe": "philips-sonicare-c3-premium-plaque-defense-burstenkopfe-4er-pack-hx9044-87",
  "art": "kopf",
  "marke": "sonicare",
  "titel": "Philips Sonicare C3 Premium Plaque Defense Bürstenköpfe (4er-Pack) HX9044/87 - HX9044/88",
  "kurz": "Sonicare C3 Premium Plaque Defense",
  "variante": "Weiß · 4 Stück",
  "text": "Der Plaque-Spezialist: flexible Seitenborsten schmiegen sich an die Zahnform an und lösen bis zu 10× mehr Plaque als eine Handzahnbürste.",
  "features": [
   "Bis zu 10× mehr Plaque-Entfernung*",
   "Flexible Seitenwände für engen Zahnkontakt",
   "BrushSync™-Chip: Handstück erinnert an den Wechsel",
   "Mittelweiche Borsten"
  ],
  "ziel": [
   "plaque"
  ],
  "bilder": [
   "bilder/philips-sonicare-c3-premium-plaque-defense-burstenkopfe-4er-pack-hx9044-87_01.jpg",
   "bilder/philips-sonicare-c3-premium-plaque-defense-burstenkopfe-4er-pack-hx9044-87_02.jpg",
   "bilder/philips-sonicare-c3-premium-plaque-defense-burstenkopfe-4er-pack-hx9044-87_03.jpg",
   "bilder/philips-sonicare-c3-premium-plaque-defense-burstenkopfe-4er-pack-hx9044-87_04.jpg"
  ],
  "optionen": [],
  "varianten": [
   {
    "opts": {
     "Farbe": "weiss"
    },
    "ean": "8710103805618",
    "preis": 48.89,
    "bild": "bilder/philips-sonicare-c3-premium-plaque-defense-burstenkopfe-4er-pack-hx9044-87_01.jpg",
    "stueck": 4
   }
  ],
  "passt": [
   "son-2100",
   "son-3100",
   "son-4100",
   "son-5300",
   "son-6100",
   "son-7100",
   "son-9000",
   "son-9900",
   "son-kids"
  ]
 },
 {
  "id": "angelcare-nachfullkassette-fur-windeleimer-classic-xl",
  "gruppe": "angelcare-nachfullkassette-fur-windeleimer-classic-xl",
  "art": "mehr",
  "marke": "angelcare",
  "hersteller": "Angelcare",
  "kat": "Baby",
  "titel": "Angelcare Nachfüllkassette für Windeleimer - Classic XL",
  "kurz": "Angelcare Nachfüllkassette Classic XL",
  "variante": "",
  "text": "Originale Nachfüllkassetten für den Angelcare Windeleimer – schließen Gerüche sicher ein und halten das Babyzimmer frisch.",
  "features": [
   "Passend für Dress-Up, Dress-Up XL und Classic XL",
   "Mehrlagige Folie mit Geruchsbarriere",
   "Als 3er-, 6er- und 8er-Pack"
  ],
  "ziel": [],
  "bilder": [
   "bilder/angelcare-nachfullkassette-fur-windeleimer-classic-xl_01.jpg",
   "bilder/angelcare-nachfullkassette-fur-windeleimer-classic-xl_02.jpg",
   "bilder/angelcare-nachfullkassette-fur-windeleimer-classic-xl_03.jpg",
   "bilder/angelcare-nachfullkassette-fur-windeleimer-classic-xl_04.jpg",
   "bilder/angelcare-nachfullkassette-fur-windeleimer-classic-xl_05.jpg",
   "bilder/angelcare-nachfullkassette-fur-windeleimer-classic-xl_06.jpg",
   "bilder/angelcare-nachfullkassette-fur-windeleimer-classic-xl_07.jpg",
   "bilder/angelcare-nachfullkassette-fur-windeleimer-classic-xl_08.jpg",
   "bilder/angelcare-nachfullkassette-fur-windeleimer-classic-xl_09.jpg"
  ],
  "optionen": [
   {
    "name": "Stück",
    "werte": [
     "3 Stück",
     "6 Stück",
     "8 Stück"
    ]
   }
  ],
  "varianten": [
   {
    "opts": {
     "Stück": "3 Stück"
    },
    "ean": "0666594203267",
    "preis": 34.99,
    "bild": "bilder/angelcare-nachfullkassette-fur-windeleimer-classic-xl_01.jpg",
    "stueck": 3,
    "einheit": "Stück"
   },
   {
    "opts": {
     "Stück": "6 Stück"
    },
    "ean": "0666594202017",
    "preis": 46.99,
    "bild": "bilder/angelcare-nachfullkassette-fur-windeleimer-classic-xl_09.jpg",
    "stueck": 6,
    "einheit": "Stück"
   },
   {
    "opts": {
     "Stück": "8 Stück"
    },
    "ean": "0666594204967",
    "preis": 54.99,
    "bild": "bilder/angelcare-nachfullkassette-fur-windeleimer-classic-xl_08.jpg",
    "stueck": 8,
    "einheit": "Stück"
   }
  ],
  "passt": []
 },
 {
  "id": "braun-series-9-pro-elektrorasierer-original-scherkopf-96m",
  "gruppe": "braun-series-9-pro-elektrorasierer-original-scherkopf-96m",
  "art": "mehr",
  "marke": "braun",
  "hersteller": "Braun",
  "kat": "Rasur",
  "titel": "Braun Series 9 Pro Elektrorasierer Scherkopf,94M, Silber, 1er Pack",
  "kurz": "Braun Series 9 Pro Scherkopf 94M",
  "variante": "",
  "text": "Der originale Ersatz-Scherkopf für Braun Series 9 Pro. Braun empfiehlt den Wechsel alle 18 Monate für eine gründliche, hautschonende Rasur.",
  "features": [
   "Für Braun Series 9 Pro und Series 9",
   "Wechsel alle 18 Monate empfohlen",
   "Farbe Silber, 1er-Pack"
  ],
  "ziel": [],
  "bilder": [
   "bilder/braun-series-9-pro-elektrorasierer-original-scherkopf-96m_01.jpg",
   "bilder/braun-series-9-pro-elektrorasierer-original-scherkopf-96m_02.jpg"
  ],
  "optionen": [],
  "varianten": [
   {
    "opts": {},
    "ean": "4210201394792",
    "preis": 69.49,
    "bild": "bilder/braun-series-9-pro-elektrorasierer-original-scherkopf-96m_01.jpg",
    "stueck": null,
    "einheit": "Stück"
   }
  ],
  "passt": []
 },
 {
  "id": "brita-maxtra-pro-pure-performance",
  "gruppe": "brita-maxtra-pro-pure-performance",
  "art": "mehr",
  "marke": "brita",
  "hersteller": "Brita",
  "kat": "Wasser",
  "titel": "Brita MAXTRA Pro Performance",
  "kurz": "Brita MAXTRA Pro Pure Performance",
  "variante": "",
  "text": "Filterkartuschen für frisch gefiltertes Wasser mit besserem Geschmack – reduzieren Kalk, Chlor und viele Rückstände.",
  "features": [
   "Für alle BRITA Tischwasserfilter mit MAXTRA",
   "Reduziert Kalk und geschmacksstörende Stoffe",
   "4er-, 6er- und 12er-Pack"
  ],
  "ziel": [],
  "bilder": [
   "bilder/brita-maxtra-pro-pure-performance_01.jpg",
   "bilder/brita-maxtra-pro-pure-performance_02.jpg",
   "bilder/brita-maxtra-pro-pure-performance_03.jpg",
   "bilder/brita-maxtra-pro-pure-performance_04.jpg",
   "bilder/brita-maxtra-pro-pure-performance_05.jpg",
   "bilder/brita-maxtra-pro-pure-performance_06.jpg",
   "bilder/brita-maxtra-pro-pure-performance_07.jpg"
  ],
  "optionen": [
   {
    "name": "Stück",
    "werte": [
     "4 Stück",
     "6 Stück",
     "12 Stück"
    ]
   }
  ],
  "varianten": [
   {
    "opts": {
     "Stück": "4 Stück"
    },
    "ean": "4006387122027",
    "preis": 39.99,
    "bild": "bilder/brita-maxtra-pro-pure-performance_01.jpg",
    "stueck": 4,
    "einheit": "Stück"
   },
   {
    "opts": {
     "Stück": "6 Stück"
    },
    "ean": "4006387122041",
    "preis": 49.99,
    "bild": "bilder/brita-maxtra-pro-pure-performance_06.jpg",
    "stueck": 6,
    "einheit": "Stück"
   },
   {
    "opts": {
     "Stück": "12 Stück"
    },
    "ean": "4006387120597",
    "preis": 69.99,
    "bild": "bilder/brita-maxtra-pro-pure-performance_07.jpg",
    "stueck": 12,
    "einheit": "Stück"
   }
  ],
  "passt": []
 },
 {
  "id": "siemens-multipack-entkalkung-reinigung",
  "gruppe": "siemens-multipack-entkalkung-reinigung",
  "art": "mehr",
  "marke": "siemens",
  "hersteller": "Siemens",
  "kat": "Kaffee-Pflege",
  "titel": "Siemens Multipack Entkalkung/Reinigung - 6 Entkalkungstabletten, 10 Reinigungstabletten passend für Kaffeevollautomaten der EQ Reihe, sowie Einbauvollautomaten",
  "kurz": "Siemens Multipack Entkalkung & Reinigung",
  "variante": "",
  "text": "Das Original-Pflegeset für Siemens EQ Kaffeevollautomaten und Einbauvollautomaten: 6 Entkalkungs- und 10 Reinigungstabletten.",
  "features": [
   "Für Siemens EQ-Serie und Einbauvollautomaten",
   "6 Entkalkungs- + 10 Reinigungstabletten",
   "Siemens Value Care Original"
  ],
  "ziel": [],
  "bilder": [
   "bilder/siemens-multipack-entkalkung-reinigung_02.jpg",
   "bilder/siemens-multipack-entkalkung-reinigung_01.jpg",
   "bilder/siemens-multipack-entkalkung-reinigung_03.jpg",
   "bilder/siemens-multipack-entkalkung-reinigung_04.jpg"
  ],
  "optionen": [],
  "varianten": [
   {
    "opts": {},
    "ean": "4242003920114",
    "preis": 42.90,
    "bild": "bilder/siemens-multipack-entkalkung-reinigung_02.jpg",
    "stueck": null,
    "einheit": "Stück"
   }
  ],
  "passt": []
 },
 {
  "id": "billy-boy-100-mixed-condoms-52mm-original-fit",
  "gruppe": "billy-boy-100-mixed-condoms-52mm-original-fit",
  "art": "mehr",
  "marke": "billy",
  "hersteller": "BILLY BOY",
  "kat": "Drogerie",
  "titel": "BILLY BOY 100 Mixed Condoms 52mm Original Fit",
  "kurz": "BILLY BOY Mixed Kondome 52 mm",
  "variante": "",
  "text": "Die große Vorratsbox mit 100 gemischten BILLY BOY Kondomen in der Original-Passform von 52 mm.",
  "features": [
   "100 Stück, gemischte Sorten",
   "Nominale Breite 52 mm, Original Fit",
   "Großpackung zum Vorratspreis"
  ],
  "ziel": [],
  "bilder": [
   "bilder/billy-boy-100-mixed-condoms-52mm-original-fit_01.jpg",
   "bilder/billy-boy-100-mixed-condoms-52mm-original-fit_02.jpg",
   "bilder/billy-boy-100-mixed-condoms-52mm-original-fit_03.jpg"
  ],
  "optionen": [],
  "varianten": [
   {
    "opts": {},
    "ean": "4008600109129",
    "preis": 27.99,
    "bild": "bilder/billy-boy-100-mixed-condoms-52mm-original-fit_01.jpg",
    "stueck": 100,
    "einheit": "Kondome"
   }
  ],
  "passt": []
 },
 {
  "id": "oral-b-io-ultimative-reinigung-original-aufsteckbursten-schwarz-10-stuck-1",
  "gruppe": "oral-b-io-ultimative-reinigung-original-aufsteckbursten-schwarz-10-stuck",
  "art": "kopf",
  "marke": "oralb",
  "titel": "Oral-B iO Ultimative Reinigung, Original Aufsteckbürsten, Schwarz, 10 Stück",
  "kurz": "Oral-B iO Ultimative Reinigung",
  "variante": "Schwarz · 8 Stück",
  "text": "Der runde, von Zahnärzten inspirierte iO-Bürstenkopf mit 16°-Borstenbündeln – exklusiv für alle Oral-B iO Zahnbürsten.",
  "features": [
   "Bis zu 100 % mehr Plaque-Entfernung*",
   "16° geneigte Borstenbündel für schwer erreichbare Stellen",
   "Indikatorborsten zeigen den Wechselzeitpunkt",
   "Nur für Oral-B iO Handstücke"
  ],
  "ziel": [
   "plaque",
   "rundum"
  ],
  "bilder": [
   "bilder/oral-b-io-ultimative-reinigung-original-aufsteckbursten-schwarz-10-stuck_05.jpg",
   "bilder/oral-b-io-ultimative-reinigung-original-aufsteckbursten-schwarz-10-stuck_02.jpg",
   "bilder/oral-b-io-ultimative-reinigung-original-aufsteckbursten-schwarz-10-stuck_03.jpg",
   "bilder/oral-b-io-ultimative-reinigung-original-aufsteckbursten-schwarz-10-stuck_04.jpg"
  ],
  "optionen": [],
  "varianten": [
   {
    "opts": {
     "Farbe": "schwarz",
     "Stück": "8 Stück"
    },
    "ean": "4210201434832",
    "preis": 63.88,
    "bild": "bilder/oral-b-io-ultimative-reinigung-original-aufsteckbursten-schwarz-10-stuck_05.jpg",
    "stueck": 8
   }
  ],
  "passt": [
   "ob-io2",
   "ob-io3",
   "ob-io4",
   "ob-io5",
   "ob-io6",
   "ob-io7",
   "ob-io8",
   "ob-io9",
   "ob-io10"
  ]
 },
 {
  "id": "oral-b-io-ultimative-reinigung-original-aufsteckbursten-schwarz-10-stuck-2",
  "gruppe": "oral-b-io-ultimative-reinigung-original-aufsteckbursten-schwarz-10-stuck",
  "art": "kopf",
  "marke": "oralb",
  "titel": "Oral-B iO Ultimative Reinigung, Original Aufsteckbürsten, Schwarz, 10 Stück",
  "kurz": "Oral-B iO Ultimative Reinigung",
  "variante": "Schwarz · 10 Stück",
  "text": "Der runde, von Zahnärzten inspirierte iO-Bürstenkopf mit 16°-Borstenbündeln – exklusiv für alle Oral-B iO Zahnbürsten.",
  "features": [
   "Bis zu 100 % mehr Plaque-Entfernung*",
   "16° geneigte Borstenbündel für schwer erreichbare Stellen",
   "Indikatorborsten zeigen den Wechselzeitpunkt",
   "Nur für Oral-B iO Handstücke"
  ],
  "ziel": [
   "plaque",
   "rundum"
  ],
  "bilder": [
   "bilder/oral-b-io-ultimative-reinigung-original-aufsteckbursten-schwarz-10-stuck_01.jpg",
   "bilder/oral-b-io-ultimative-reinigung-original-aufsteckbursten-schwarz-10-stuck_02.jpg",
   "bilder/oral-b-io-ultimative-reinigung-original-aufsteckbursten-schwarz-10-stuck_03.jpg",
   "bilder/oral-b-io-ultimative-reinigung-original-aufsteckbursten-schwarz-10-stuck_04.jpg"
  ],
  "optionen": [],
  "varianten": [
   {
    "opts": {
     "Farbe": "schwarz",
     "Stück": "10 Stück"
    },
    "ean": "8700216777131",
    "preis": 65.84,
    "bild": "bilder/oral-b-io-ultimative-reinigung-original-aufsteckbursten-schwarz-10-stuck_01.jpg",
    "stueck": 10
   }
  ],
  "passt": [
   "ob-io2",
   "ob-io3",
   "ob-io4",
   "ob-io5",
   "ob-io6",
   "ob-io7",
   "ob-io8",
   "ob-io9",
   "ob-io10"
  ]
 },
 {
  "id": "oral-b-io-ultimative-reinigung-original-aufsteckbursten-schwarz-10-stuck-3",
  "gruppe": "oral-b-io-ultimative-reinigung-original-aufsteckbursten-schwarz-10-stuck",
  "art": "kopf",
  "marke": "oralb",
  "titel": "Oral-B iO Ultimative Reinigung, Original Aufsteckbürsten, Schwarz, 10 Stück",
  "kurz": "Oral-B iO Ultimative Reinigung",
  "variante": "Weiß · 8 Stück",
  "text": "Der runde, von Zahnärzten inspirierte iO-Bürstenkopf mit 16°-Borstenbündeln – exklusiv für alle Oral-B iO Zahnbürsten.",
  "features": [
   "Bis zu 100 % mehr Plaque-Entfernung*",
   "16° geneigte Borstenbündel für schwer erreichbare Stellen",
   "Indikatorborsten zeigen den Wechselzeitpunkt",
   "Nur für Oral-B iO Handstücke"
  ],
  "ziel": [
   "plaque",
   "rundum"
  ],
  "bilder": [
   "bilder/oral-b-io-ultimative-reinigung-original-aufsteckbursten-schwarz-10-stuck_06.jpg",
   "bilder/oral-b-io-ultimative-reinigung-original-aufsteckbursten-schwarz-10-stuck_02.jpg",
   "bilder/oral-b-io-ultimative-reinigung-original-aufsteckbursten-schwarz-10-stuck_03.jpg",
   "bilder/oral-b-io-ultimative-reinigung-original-aufsteckbursten-schwarz-10-stuck_04.jpg"
  ],
  "optionen": [],
  "varianten": [
   {
    "opts": {
     "Farbe": "weiss",
     "Stück": "8 Stück"
    },
    "ean": "4210201434818",
    "preis": 63.36,
    "bild": "bilder/oral-b-io-ultimative-reinigung-original-aufsteckbursten-schwarz-10-stuck_06.jpg",
    "stueck": 8
   }
  ],
  "passt": [
   "ob-io2",
   "ob-io3",
   "ob-io4",
   "ob-io5",
   "ob-io6",
   "ob-io7",
   "ob-io8",
   "ob-io9",
   "ob-io10"
  ]
 },
 {
  "id": "oral-b-io-ultimative-reinigung-original-aufsteckbursten-schwarz-10-stuck-4",
  "gruppe": "oral-b-io-ultimative-reinigung-original-aufsteckbursten-schwarz-10-stuck",
  "art": "kopf",
  "marke": "oralb",
  "titel": "Oral-B iO Ultimative Reinigung, Original Aufsteckbürsten, Schwarz, 10 Stück",
  "kurz": "Oral-B iO Ultimative Reinigung",
  "variante": "Weiß · 10 Stück",
  "text": "Der runde, von Zahnärzten inspirierte iO-Bürstenkopf mit 16°-Borstenbündeln – exklusiv für alle Oral-B iO Zahnbürsten.",
  "features": [
   "Bis zu 100 % mehr Plaque-Entfernung*",
   "16° geneigte Borstenbündel für schwer erreichbare Stellen",
   "Indikatorborsten zeigen den Wechselzeitpunkt",
   "Nur für Oral-B iO Handstücke"
  ],
  "ziel": [
   "plaque",
   "rundum"
  ],
  "bilder": [
   "bilder/oral-b-io-ultimative-reinigung-original-aufsteckbursten-schwarz-10-stuck_07.jpg",
   "bilder/oral-b-io-ultimative-reinigung-original-aufsteckbursten-schwarz-10-stuck_02.jpg",
   "bilder/oral-b-io-ultimative-reinigung-original-aufsteckbursten-schwarz-10-stuck_03.jpg",
   "bilder/oral-b-io-ultimative-reinigung-original-aufsteckbursten-schwarz-10-stuck_04.jpg"
  ],
  "optionen": [],
  "varianten": [
   {
    "opts": {
     "Farbe": "weiss",
     "Stück": "10 Stück"
    },
    "ean": "8700216777063",
    "preis": 68.58,
    "bild": "bilder/oral-b-io-ultimative-reinigung-original-aufsteckbursten-schwarz-10-stuck_07.jpg",
    "stueck": 10
   }
  ],
  "passt": [
   "ob-io2",
   "ob-io3",
   "ob-io4",
   "ob-io5",
   "ob-io6",
   "ob-io7",
   "ob-io8",
   "ob-io9",
   "ob-io10"
  ]
 },
 {
  "id": "oneblade-ersatzklinge-360",
  "gruppe": "oneblade-ersatzklinge-360",
  "art": "mehr",
  "marke": "oneblade",
  "hersteller": "Philips",
  "kat": "Rasur",
  "titel": "OneBlade Ersatzklinge 360",
  "kurz": "Philips OneBlade 360 Ersatzklinge",
  "variante": "",
  "text": "Die 360-Grad-Klinge passt sich in alle Richtungen an die Gesichtskonturen an – trimmen, stylen und rasieren mit weniger Zügen.",
  "features": [
   "Für alle Philips OneBlade Handstücke",
   "360°-Klinge für Konturen",
   "Wechsel etwa alle 4 Monate empfohlen"
  ],
  "ziel": [],
  "bilder": [
   "bilder/oneblade-ersatzklinge-360_01.jpg",
   "bilder/oneblade-ersatzklinge-360_02.jpg",
   "bilder/oneblade-ersatzklinge-360_03.jpg",
   "bilder/oneblade-ersatzklinge-360_04.jpg"
  ],
  "optionen": [],
  "varianten": [
   {
    "opts": {},
    "ean": "8720689023504",
    "preis": 37.99,
    "bild": "bilder/oneblade-ersatzklinge-360_01.jpg",
    "stueck": null,
    "einheit": "Stück"
   }
  ],
  "passt": []
 },
 {
  "id": "philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9044-87-kopie-1",
  "gruppe": "philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9044-87-kopie",
  "art": "kopf",
  "marke": "sonicare",
  "titel": "Philips Sonicare A3 Premium Gum Care Bürstenköpfe (4er-Pack) HX9094/87 - HX9094/88",
  "kurz": "Sonicare A3 Premium All-in-One",
  "variante": "Schwarz · 4 Stück",
  "text": "Der Alleskönner der Premium-Serie: entfernt Plaque, Verfärbungen und pflegt das Zahnfleisch – mit unverwechselbaren orangefarbenen Borsten.",
  "features": [
   "Plaque, Verfärbungen und Zahnfleisch in einem Kopf",
   "Bis zu 20× mehr Plaque-Entfernung*",
   "BrushSync™-Wechselerinnerung",
   "Weiche Borsten"
  ],
  "ziel": [
   "rundum",
   "weiss",
   "plaque"
  ],
  "bilder": [
   "bilder/philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9044-87-kopie_07.jpg",
   "bilder/philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9044-87-kopie_02.jpg",
   "bilder/philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9044-87-kopie_03.jpg",
   "bilder/philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9044-87-kopie_04.jpg",
   "bilder/philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9044-87-kopie_05.jpg",
   "bilder/philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9044-87-kopie_06.jpg"
  ],
  "optionen": [],
  "varianten": [
   {
    "opts": {
     "Farbe": "Schwarz"
    },
    "ean": "8720689022996",
    "preis": 52.99,
    "bild": "bilder/philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9044-87-kopie_07.jpg",
    "stueck": 4
   }
  ],
  "passt": [
   "son-2100",
   "son-3100",
   "son-4100",
   "son-5300",
   "son-6100",
   "son-7100",
   "son-9000",
   "son-9900",
   "son-kids"
  ]
 },
 {
  "id": "philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9044-87-kopie-2",
  "gruppe": "philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9044-87-kopie",
  "art": "kopf",
  "marke": "sonicare",
  "titel": "Philips Sonicare A3 Premium Gum Care Bürstenköpfe (4er-Pack) HX9094/87 - HX9094/88",
  "kurz": "Sonicare A3 Premium All-in-One",
  "variante": "Weiß · 4 Stück",
  "text": "Der Alleskönner der Premium-Serie: entfernt Plaque, Verfärbungen und pflegt das Zahnfleisch – mit unverwechselbaren orangefarbenen Borsten.",
  "features": [
   "Plaque, Verfärbungen und Zahnfleisch in einem Kopf",
   "Bis zu 20× mehr Plaque-Entfernung*",
   "BrushSync™-Wechselerinnerung",
   "Weiche Borsten"
  ],
  "ziel": [
   "rundum",
   "weiss",
   "plaque"
  ],
  "bilder": [
   "bilder/philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9044-87-kopie_01.jpg",
   "bilder/philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9044-87-kopie_02.jpg",
   "bilder/philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9044-87-kopie_03.jpg",
   "bilder/philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9044-87-kopie_04.jpg",
   "bilder/philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9044-87-kopie_05.jpg",
   "bilder/philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9044-87-kopie_06.jpg"
  ],
  "optionen": [],
  "varianten": [
   {
    "opts": {
     "Farbe": "Weiß"
    },
    "ean": "8720689020695",
    "preis": 68.87,
    "bild": "bilder/philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9044-87-kopie_01.jpg",
    "stueck": 4
   }
  ],
  "passt": [
   "son-2100",
   "son-3100",
   "son-4100",
   "son-5300",
   "son-6100",
   "son-7100",
   "son-9000",
   "son-9900",
   "son-kids"
  ]
 },
 {
  "id": "philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9054-88-1",
  "gruppe": "philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9054-88",
  "art": "kopf",
  "marke": "sonicare",
  "titel": "Philips Sonicare G3 Premium Gum Care Bürstenköpfe (4er-Pack) HX9054/87 - HX9054/88",
  "kurz": "Sonicare G3 Premium Gum Care",
  "variante": "Schwarz · 4 Stück",
  "text": "Für gesünderes Zahnfleisch in nur zwei Wochen: weiche, flexible Seitenborsten massieren sanft entlang des Zahnfleischrands.",
  "features": [
   "Bis zu 7× gesünderes Zahnfleisch in 2 Wochen*",
   "Extra weiche, flexible Seitenwände",
   "BrushSync™-Wechselerinnerung",
   "Ideal bei empfindlichem Zahnfleisch"
  ],
  "ziel": [
   "zahnfleisch"
  ],
  "bilder": [
   "bilder/philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9054-88_04.jpg",
   "bilder/philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9054-88_02.jpg",
   "bilder/philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9054-88_03.jpg"
  ],
  "optionen": [],
  "varianten": [
   {
    "opts": {
     "Farbe": "Schwarz"
    },
    "ean": "8710103805663",
    "preis": 56.43,
    "bild": "bilder/philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9054-88_04.jpg",
    "stueck": 4
   }
  ],
  "passt": [
   "son-2100",
   "son-3100",
   "son-4100",
   "son-5300",
   "son-6100",
   "son-7100",
   "son-9000",
   "son-9900",
   "son-kids"
  ]
 },
 {
  "id": "philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9054-88-2",
  "gruppe": "philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9054-88",
  "art": "kopf",
  "marke": "sonicare",
  "titel": "Philips Sonicare G3 Premium Gum Care Bürstenköpfe (4er-Pack) HX9054/87 - HX9054/88",
  "kurz": "Sonicare G3 Premium Gum Care",
  "variante": "Weiß · 4 Stück",
  "text": "Für gesünderes Zahnfleisch in nur zwei Wochen: weiche, flexible Seitenborsten massieren sanft entlang des Zahnfleischrands.",
  "features": [
   "Bis zu 7× gesünderes Zahnfleisch in 2 Wochen*",
   "Extra weiche, flexible Seitenwände",
   "BrushSync™-Wechselerinnerung",
   "Ideal bei empfindlichem Zahnfleisch"
  ],
  "ziel": [
   "zahnfleisch"
  ],
  "bilder": [
   "bilder/philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9054-88_01.jpg",
   "bilder/philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9054-88_02.jpg",
   "bilder/philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9054-88_03.jpg"
  ],
  "optionen": [],
  "varianten": [
   {
    "opts": {
     "Farbe": "Weiß"
    },
    "ean": "8710103805656",
    "preis": 58.63,
    "bild": "bilder/philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9054-88_01.jpg",
    "stueck": 4
   }
  ],
  "passt": [
   "son-2100",
   "son-3100",
   "son-4100",
   "son-5300",
   "son-6100",
   "son-7100",
   "son-9000",
   "son-9900",
   "son-kids"
  ]
 },
 {
  "id": "philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie-1",
  "gruppe": "philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie",
  "art": "kopf",
  "marke": "sonicare",
  "titel": "Philips Sonicare W2 Optimal Bürstenköpfe (4er-Pack) HX6064/87 - HX6064/88 - HX6068/87 - HX6068/88",
  "kurz": "Sonicare W2 Optimal White",
  "variante": "Weiß · 4 Stück",
  "text": "Für ein strahlendes Lächeln: das dichte, zentrale Polierfeld entfernt Verfärbungen von Kaffee, Tee & Co. – für weißere Zähne in nur einer Woche.",
  "features": [
   "Bis zu 2× mehr Verfärbungen entfernt*",
   "Zentrales Polierfeld aus dichten Borsten",
   "BrushSync™-Wechselerinnerung",
   "Als 4er- und 8er-Pack erhältlich"
  ],
  "ziel": [
   "weiss"
  ],
  "bilder": [
   "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_08.jpg",
   "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_02.jpg",
   "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_03.jpg",
   "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_04.jpg",
   "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_05.jpg",
   "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_06.jpg",
   "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_07.jpg"
  ],
  "optionen": [],
  "varianten": [
   {
    "opts": {
     "Stück": "4 Stück",
     "Farbe": "Weiß"
    },
    "ean": "7426892142667",
    "preis": 43.7,
    "bild": "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_08.jpg",
    "stueck": 4
   }
  ],
  "passt": [
   "son-2100",
   "son-3100",
   "son-4100",
   "son-5300",
   "son-6100",
   "son-7100",
   "son-9000",
   "son-9900",
   "son-kids"
  ]
 },
 {
  "id": "philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie-2",
  "gruppe": "philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie",
  "art": "kopf",
  "marke": "sonicare",
  "titel": "Philips Sonicare W2 Optimal Bürstenköpfe (4er-Pack) HX6064/87 - HX6064/88 - HX6068/87 - HX6068/88",
  "kurz": "Sonicare W2 Optimal White",
  "variante": "Schwarz · 4 Stück",
  "text": "Für ein strahlendes Lächeln: das dichte, zentrale Polierfeld entfernt Verfärbungen von Kaffee, Tee & Co. – für weißere Zähne in nur einer Woche.",
  "features": [
   "Bis zu 2× mehr Verfärbungen entfernt*",
   "Zentrales Polierfeld aus dichten Borsten",
   "BrushSync™-Wechselerinnerung",
   "Als 4er- und 8er-Pack erhältlich"
  ],
  "ziel": [
   "weiss"
  ],
  "bilder": [
   "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_09.jpg",
   "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_02.jpg",
   "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_03.jpg",
   "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_04.jpg",
   "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_05.jpg",
   "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_06.jpg",
   "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_07.jpg"
  ],
  "optionen": [],
  "varianten": [
   {
    "opts": {
     "Stück": "4 Stück",
     "Farbe": "Schwarz"
    },
    "ean": "8710103850366",
    "preis": 44.89,
    "bild": "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_09.jpg",
    "stueck": 4
   }
  ],
  "passt": [
   "son-2100",
   "son-3100",
   "son-4100",
   "son-5300",
   "son-6100",
   "son-7100",
   "son-9000",
   "son-9900",
   "son-kids"
  ]
 },
 {
  "id": "philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie-3",
  "gruppe": "philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie",
  "art": "kopf",
  "marke": "sonicare",
  "titel": "Philips Sonicare W2 Optimal Bürstenköpfe (4er-Pack) HX6064/87 - HX6064/88 - HX6068/87 - HX6068/88",
  "kurz": "Sonicare W2 Optimal White",
  "variante": "Weiß · 8 Stück",
  "text": "Für ein strahlendes Lächeln: das dichte, zentrale Polierfeld entfernt Verfärbungen von Kaffee, Tee & Co. – für weißere Zähne in nur einer Woche.",
  "features": [
   "Bis zu 2× mehr Verfärbungen entfernt*",
   "Zentrales Polierfeld aus dichten Borsten",
   "BrushSync™-Wechselerinnerung",
   "Als 4er- und 8er-Pack erhältlich"
  ],
  "ziel": [
   "weiss"
  ],
  "bilder": [
   "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_10.jpg",
   "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_02.jpg",
   "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_03.jpg",
   "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_04.jpg",
   "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_05.jpg",
   "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_06.jpg",
   "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_07.jpg"
  ],
  "optionen": [],
  "varianten": [
   {
    "opts": {
     "Stück": "8 Stück",
     "Farbe": "Weiß"
    },
    "ean": "8710103850410",
    "preis": 74.89,
    "bild": "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_10.jpg",
    "stueck": 8
   }
  ],
  "passt": [
   "son-2100",
   "son-3100",
   "son-4100",
   "son-5300",
   "son-6100",
   "son-7100",
   "son-9000",
   "son-9900",
   "son-kids"
  ]
 },
 {
  "id": "philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie-4",
  "gruppe": "philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie",
  "art": "kopf",
  "marke": "sonicare",
  "titel": "Philips Sonicare W2 Optimal Bürstenköpfe (4er-Pack) HX6064/87 - HX6064/88 - HX6068/87 - HX6068/88",
  "kurz": "Sonicare W2 Optimal White",
  "variante": "Schwarz · 8 Stück",
  "text": "Für ein strahlendes Lächeln: das dichte, zentrale Polierfeld entfernt Verfärbungen von Kaffee, Tee & Co. – für weißere Zähne in nur einer Woche.",
  "features": [
   "Bis zu 2× mehr Verfärbungen entfernt*",
   "Zentrales Polierfeld aus dichten Borsten",
   "BrushSync™-Wechselerinnerung",
   "Als 4er- und 8er-Pack erhältlich"
  ],
  "ziel": [
   "weiss"
  ],
  "bilder": [
   "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_11.jpg",
   "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_02.jpg",
   "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_03.jpg",
   "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_04.jpg",
   "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_05.jpg",
   "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_06.jpg",
   "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_07.jpg"
  ],
  "optionen": [],
  "varianten": [
   {
    "opts": {
     "Stück": "8 Stück",
     "Farbe": "Schwarz"
    },
    "ean": "8710103860341",
    "preis": 69.89,
    "bild": "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie_11.jpg",
    "stueck": 8
   }
  ],
  "passt": [
   "son-2100",
   "son-3100",
   "son-4100",
   "son-5300",
   "son-6100",
   "son-7100",
   "son-9000",
   "son-9900",
   "son-kids"
  ]
 },
 {
  "id": "philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx9004-87",
  "gruppe": "philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx9004-87",
  "art": "kopf",
  "marke": "sonicare",
  "titel": "Philips Sonicare I InterCare Bürstenköpfe (4er-Pack) HX9004/87",
  "kurz": "Sonicare i InterCare",
  "variante": "4 Stück",
  "text": "Extralange Borsten dringen tief in die Zahnzwischenräume ein – der Kopf für alle, die es zwischen den Zähnen besonders gründlich mögen.",
  "features": [
   "Bis zu 10× mehr Plaque-Entfernung in den Zwischenräumen*",
   "Extralange, dichte Borstenbündel",
   "BrushSync™-Wechselerinnerung",
   "Mittlere Borstenhärte"
  ],
  "ziel": [
   "zwischenraum",
   "plaque"
  ],
  "bilder": [
   "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx9004-87_01.jpg",
   "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx9004-87_02.jpg",
   "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx9004-87_03.jpg"
  ],
  "optionen": [],
  "varianten": [
   {
    "opts": {},
    "ean": "8720689052658",
    "preis": 64.99,
    "bild": "bilder/philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx9004-87_01.jpg",
    "stueck": 4
   }
  ],
  "passt": [
   "son-2100",
   "son-3100",
   "son-4100",
   "son-5300",
   "son-6100",
   "son-7100",
   "son-9000",
   "son-9900",
   "son-kids"
  ]
 },
 {
  "id": "philips-sonicare-for-kids-burstenkopfe-4er-pack-hx6044-90",
  "gruppe": "philips-sonicare-for-kids-burstenkopfe-4er-pack-hx6044-90",
  "art": "kopf",
  "marke": "sonicare",
  "titel": "Philips Sonicare For Kids 7+ Bürstenköpfe (4er-Pack) HX6044/90",
  "kurz": "Sonicare For Kids 7+",
  "variante": "Weiß · 4 Stück",
  "text": "Für Schulkinder ab 7 Jahren: der Standard-Kids-Kopf mit gummierter Rückseite und extra weichen Borsten für die bleibenden Zähne.",
  "features": [
   "Speziell für Kinder ab 7 Jahren",
   "Gummierte Rückseite schützt Zähne und Zahnfleisch",
   "Extra weiche Borsten",
   "Passend für Sonicare For Kids und Erwachsenen-Handstücke"
  ],
  "ziel": [
   "kinder"
  ],
  "bilder": [
   "bilder/philips-sonicare-for-kids-burstenkopfe-4er-pack-hx6044-90_01.jpg",
   "bilder/philips-sonicare-for-kids-burstenkopfe-4er-pack-hx6044-90_02.jpg",
   "bilder/philips-sonicare-for-kids-burstenkopfe-4er-pack-hx6044-90_03.jpg",
   "bilder/philips-sonicare-for-kids-burstenkopfe-4er-pack-hx6044-90_04.jpg"
  ],
  "optionen": [],
  "varianten": [
   {
    "opts": {
     "Farbe": "Weiß"
    },
    "ean": "8710103659488",
    "preis": 35.99,
    "bild": "bilder/philips-sonicare-for-kids-burstenkopfe-4er-pack-hx6044-90_01.jpg",
    "stueck": 4
   }
  ],
  "passt": [
   "son-2100",
   "son-3100",
   "son-4100",
   "son-5300",
   "son-6100",
   "son-7100",
   "son-9000",
   "son-9900",
   "son-kids"
  ]
 },
 {
  "id": "philips-sonicare-for-kids-burstenkopfe-4er-pack-hx6034-90",
  "gruppe": "philips-sonicare-for-kids-burstenkopfe-4er-pack-hx6034-90",
  "art": "kopf",
  "marke": "sonicare",
  "titel": "Philips Sonicare For Kids 3+ Bürstenköpfe (4er-Pack) HX6034/90",
  "kurz": "Sonicare For Kids 3+",
  "variante": "Weiß · 4 Stück",
  "text": "Der kompakte Kopf für die Kleinsten ab 3 Jahren – klein genug für Milchzähne, sanft genug für empfindliches Zahnfleisch.",
  "features": [
   "Kompakter Kopf für Kinder von 3 bis 6 Jahren",
   "Extra weiche, abgerundete Borsten",
   "Gummierte Rückseite",
   "Klick-Aufsteckung für alle Sonicare-Handstücke"
  ],
  "ziel": [
   "kinder"
  ],
  "bilder": [
   "bilder/philips-sonicare-for-kids-burstenkopfe-4er-pack-hx6034-90_01.jpg",
   "bilder/philips-sonicare-for-kids-burstenkopfe-4er-pack-hx6034-90_02.jpg",
   "bilder/philips-sonicare-for-kids-burstenkopfe-4er-pack-hx6034-90_03.jpg",
   "bilder/philips-sonicare-for-kids-burstenkopfe-4er-pack-hx6034-90_04.jpg"
  ],
  "optionen": [],
  "varianten": [
   {
    "opts": {
     "Farbe": "Weiß"
    },
    "ean": "8710103659471",
    "preis": 35.99,
    "bild": "bilder/philips-sonicare-for-kids-burstenkopfe-4er-pack-hx6034-90_01.jpg",
    "stueck": 4
   }
  ],
  "passt": [
   "son-2100",
   "son-3100",
   "son-4100",
   "son-5300",
   "son-6100",
   "son-7100",
   "son-9000",
   "son-9900",
   "son-kids"
  ]
 }
];

/* Elektrische Zahnbürsten Oral-B iO (Preise: oralb.de + 40 €, Stand 09.10.2026; EAN geprüft, Prüfziffer ok) */
window.PRODUKTE.push(...[
  { id: 'oral-b-io10', modell: 'iO 10', farbe: 'Cosmic Black', ean: '4210201435587', preis: 319.99,
    titel: 'Oral-B iO 10 Elektrische Zahnbürste | 1 Aufsteckbürste | Lade-Reise-Etui',
    text: 'Oral-Bs beste Zahnbürste: Die iO Sense Ladestation zeigt dir live, wie gut du putzt – mit Farbdisplay, KI-Putzzonenerkennung und Lade-Reise-Etui.',
    features: ['iO Magnetantrieb mit sanften Mikrovibrationen', '7 Putzmodi und interaktives Farbdisplay', 'iO Sense Ladestation mit Putz-Feedback', 'Lade-Reise-Etui, 1 Aufsteckbürste'],
    bild: 'bilder/oral-b-io10-cosmic-black_01.jpg' },
  { id: 'oral-b-io9', modell: 'iO 9', farbe: 'Black Onyx', ean: '4210201408666', preis: 239.99,
    titel: 'Oral-B iO Series 9 Elektrische Zahnbürste, Lade-Reiseetui',
    text: 'Farbdisplay, 3D-Putzzonenerkennung per KI und Schnellladestation – Testsieger bei CHIP. Mit Lade-Reise-Etui für unterwegs.',
    features: ['iO Magnetantrieb mit sanften Mikrovibrationen', '7 Putzmodi und Farbdisplay', '3D-Putzzonenerkennung per KI', 'Lade-Reise-Etui und Schnellladestation'],
    bild: 'bilder/oral-b-io9-black-onyx_01.jpg' },
  { id: 'oral-b-io6', modell: 'iO 6', farbe: 'Black Lava', ean: '4210201445111', preis: 169.99,
    titel: 'Oral-B iO 6 Elektrische Zahnbürste | 2 Aufsteckbürsten | Reise-Etui | Aufsteckbürstenhalter',
    text: 'Interaktives Display für angeleitetes Putzen, 5 Putzmodi und intelligente Andruckkontrolle. Mit zwei Aufsteckbürsten, Halter und Reise-Etui.',
    features: ['iO Magnetantrieb mit sanften Mikrovibrationen', '5 Putzmodi', 'Interaktives Zahnbürsten-Display', '2 Aufsteckbürsten, Aufsteckbürstenhalter, Reise-Etui'],
    bild: 'bilder/oral-b-io6-black-lava_01.jpg' },
  { id: 'oral-b-io5', modell: 'iO 5', farbe: 'Matt Black', ean: '4210201415107', preis: 139.99,
    titel: 'Oral-B iO 5 Elektrische Zahnbürste | 1 Aufsteckbürste | Reise-Etui',
    text: 'Der Einstieg in die iO-Welt: 5 Putzmodi für eine personalisierte Reinigung, intelligente Andruckkontrolle und Bluetooth mit Oral-B App.',
    features: ['iO Magnetantrieb mit sanften Mikrovibrationen', '5 Putzmodi', 'Intelligente Andruckkontrolle mit Leuchtring', 'Reise-Etui, 1 Aufsteckbürste'],
    bild: 'bilder/oral-b-io5-matt-black_01.jpg' }
].map(z => ({
  id: z.id, gruppe: z.id, art: 'buerste', marke: 'oralb', hersteller: 'Oral-B', kat: 'Elektrische Zahnbürste',
  titel: z.titel, kurz: 'Oral-B ' + z.modell, variante: z.farbe, text: z.text,
  features: z.features.concat('Passt für alle Oral-B iO Aufsteckbürsten'), ziel: [], bilder: [z.bild], optionen: [],
  varianten: [{ opts: { Farbe: z.farbe }, ean: z.ean, preis: z.preis, bild: z.bild, stueck: 1, einheit: 'Stück' }],
  passt: []
})));

/* Lokales Foto fehlt noch? Dann lädt app.js das Foto von shop.braun.de, ohne Internet die Zeichnung bilder/scherkopf.svg */
window.BILD_ALT = { 'bilder/braun-series-7-70s.jpg': 'https://static.thcdn.com/productimg/original/12519363-5235277396975486.jpg', 'bilder/braun-series-5-52s.jpg': 'https://static.thcdn.com/productimg/original/14296506-1725277397031019.jpg' };
/* Braun Ersatz-Scherköpfe (EAN von Bruce, 09.10.2026). Bilder laden aus dem Netz (Produktfotos von shop.braun.de);
   ohne Internet springt app.js auf bilder/scherkopf.svg um. Eigene Fotos einfach unter bilder/ ablegen und hier eintragen. */
window.PRODUKTE.push(...[
  { id: 'braun-series-7-kombipack-70s', serie: 'Series 7', modell: '70S', ean: '4210201072942', preis: 49.99,
    bild: 'bilder/braun-series-7-70s.jpg',
    text: 'Original Braun Ersatz-Scherteil 70S (Scherfolie und Klingenblock) für Braun Series 7 Rasierer der älteren Generation. Für eine gründliche Rasur alle 18 Monate wechseln.',
    features: ['Für Braun Series 7 (790cc, 760cc, 750cc, 7898cc u. a.)', 'Scherfolie und Klingenblock in einem', 'Wechsel alle 18 Monate empfohlen', 'Farbe Silber, 1er-Pack'] },
  { id: 'braun-series-5-kombipack-52s', serie: 'Series 5', modell: '52S', ean: '4210201072195', preis: 50.99,
    bild: 'bilder/braun-series-5-52s.jpg',
    text: 'Original Braun Ersatz-Scherkopf 52S für die neue Braun Series 5 und Series 6. Mit Scherfolie und Klingenblock für eine glatte, hautschonende Rasur.',
    features: ['Für Braun Series 5 und Series 6 (neue Generation)', 'Scherfolie und Klingenblock in einem', 'Wechsel alle 18 Monate empfohlen', 'Farbe Silber, 1er-Pack'] }
].map(z => ({
  id: z.id, gruppe: z.id, art: 'mehr', marke: 'braun', hersteller: 'Braun', kat: 'Rasur',
  titel: `Braun ${z.serie} Ersatz-Scherkopf ${z.modell}, Silber, 1er Pack`, kurz: `Braun ${z.serie} Scherkopf ${z.modell}`, variante: '',
  text: z.text, features: z.features, ziel: [], bilder: [z.bild, ...[2, 3, 4].map(n => z.bild.replace('.jpg', `_0${n}.jpg`))], optionen: [],
  varianten: [{ opts: {}, ean: z.ean, preis: z.preis, bild: z.bild, stueck: null, einheit: 'Stück' }],
  passt: []
})));

/* Galerien je Variante (11.10.): nur Bilder in der passenden Farbe und Packungsgröße */
(() => {
  const B = (pre, nums) => nums.map(n => `bilder/${pre}_${String(n).padStart(2, '0')}.jpg`);
  const C3 = 'philips-sonicare-c3-premium-plaque-defense-burstenkopfe-4er-pack-hx9044-87',
    IO = 'oral-b-io-ultimative-reinigung-original-aufsteckbursten-schwarz-10-stuck',
    G4 = 'philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9044-87-kopie',
    G5 = 'philips-sonicare-premium-gum-care-burstenkopfe-4er-pack-hx9054-88',
    W2 = 'philips-sonicare-i-intercare-burstenkopfe-4er-pack-hx6064-87-kopie';
  const FIX = {
    [C3 + '-1']: B(C3, [5, 4]),               // Schwarz
    [C3 + '-2']: B(C3, [1, 2, 3, 4]),         // Weiß
    [IO + '-1']: B(IO, [5, 2, 3, 4]),         // Schwarz 8
    [IO + '-2']: B(IO, [1, 2, 3, 4]),         // Schwarz 10
    [IO + '-3']: B(IO, [6]),                  // Weiß 8
    [IO + '-4']: B(IO, [7]),                  // Weiß 10
    [G4 + '-1']: B(G4, [7, 2, 3, 4]),         // Schwarz
    [G4 + '-2']: B(G4, [1, 6, 5]),            // Weiß
    [G5 + '-1']: B(G5, [4, 2]),               // Schwarz
    [G5 + '-2']: B(G5, [1, 3]),               // Weiß
    [W2 + '-1']: B(W2, [8, 2, 3]),            // Weiß 4
    [W2 + '-2']: B(W2, [9, 5, 4, 6, 7]),      // Schwarz 4
    [W2 + '-3']: B(W2, [10, 2, 3]),           // Weiß 8
    [W2 + '-4']: B(W2, [11, 4, 6, 7])         // Schwarz 8
  };
  window.PRODUKTE.forEach(p => { if (FIX[p.id]) { p.bilder = FIX[p.id]; p.varianten.forEach(v => { v.bild = FIX[p.id][0]; }); } });
})();

/* Zentrale Shop-Angaben (Produktseite, Warenkorb und Rechtstexte lesen von hier) */
window.SHOP_INFO = { lieferzeit: '1–3 Werktage', mwst: 'inkl. 19 % MwSt.' };

// Aus dem Sortiment genommen (Bruce, 12.10.): Brita, Angelcare, OneBlade-Klinge
window.PRODUKTE = window.PRODUKTE.filter(p => !['brita', 'angelcare', 'oneblade'].includes(p.marke));
